import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function relatorioIndicadorNivelClassificacaoReducer(state = initialState.relatorioIndicadorNivelClassificacao, action){
    switch(action.type) {
        case types.RELAT_INDICADOR_NIVEL_CLASSIFICACAO:
            
            return action.relatorioIndicadorNivelClassificacao;
        default:
            return state;
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/reduces/relatorioIndicadorNivelClassificacaoReducer.js
 **/